<template>
  <component
    :is="iconComponent"
    v-bind="$attrs"
    :class="props.class"
    :stroke-width="props.strokeWidth"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent, computed } from 'vue';

interface Props {
  name: string;
  class?: string;
  strokeWidth?: number;
  size?: number;
  color?: string;
  absoluteStrokeWidth?: boolean;
  defaultClass?: string;
}

defineOptions({ name: 'Icon' });

const props = defineProps<Props>();

// Use a map or a dynamic import to get the icon component
// This approach ensures we only load the icons we need, dynamically.
const iconComponent = computed(() => {
  if (!props.name) {
    return null;
  }
  // Lucide icon names are typically PascalCase
  const iconName = props.name
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join('');

  return defineAsyncComponent({
    loader: async () => {
      const module = await import('lucide-vue-next');
      return (module as Record<string, unknown>)[iconName] || module.AlertCircle;
    },
    errorComponent: () => null,
  });
});
</script>
